import { render, staticRenderFns } from "./matchingDialog.vue?vue&type=template&id=fde831c0&scoped=true"
import script from "./matchingDialog.vue?vue&type=script&lang=js"
export * from "./matchingDialog.vue?vue&type=script&lang=js"
import style0 from "./matchingDialog.vue?vue&type=style&index=0&id=fde831c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde831c0",
  null
  
)

export default component.exports